import { useTheme } from "./use-theme";

type UseThemeAsset = (lightModeAsset: string, darkModeAsset: string) => string;

export const useThemeAsset: UseThemeAsset = (lightModeAsset, darkModeAsset) => {
  const { effectiveTheme } = useTheme();
  const asset = effectiveTheme === 'dark' ? darkModeAsset : lightModeAsset;
  return asset;
};